<template>
  <div class="distribution-date__area">
    <div class="distribution-date__head">
      <div class="distribution-date__head-comment">
        <div class="distribution-date__head-comment-inner">
          <div class="distribution-date__head-comment-text">
            本日 <span style="font-weight: 500;">{{ date }}</span> リリース申請をした場合
          </div>
        </div>
      </div>
      <div class="distribution-date__head-block">
        <div class="distribution-date">
          <div class="distribution-date__text">
            ストア別の最短配信日
          </div>
          <div class="distribution-date__number">
            {{ earliestReleaseDate }}
          </div>
        </div>
        <div class="distribution-date">
          <div class="distribution-date__text">
            全ストア同一最短の配信日
          </div>
          <div class="distribution-date__number">
            {{ minDate }}
          </div>
        </div>
      </div>
      <div class="distribution-date__btn">
        <div
          class="c-btn c-btn--accordion"
          :class="{ 'open': minRealeaaseDetailShow }"
          @click.prevent="onCloseClicked">
          {{ changeBtnText }}
          <span></span>
        </div>
      </div>
    </div>
    <div
      v-if="minRealeaaseDetailShow"
      class="distribution-date__bottom">
      <div class="distribution-date__bottom-title-block">
        <div class="distribution-date__bottom-title">ストア別最短配信日</div>
        <div class="distribution-date__bottom-text">
          本日、配信審査を申請した場合、各ストアの最短配信日は下記となります。
        </div>
        <div class="distribution-date__bottom-text">
          ※最短配信日は、配信ストア側の審査状況により遅れる場合がございます。
        </div>
      </div>
      <div class="distribution-date__content">
        <div class="distribution-date__block distribution-date__block--subscription">
          <div class="distribution-date__block-title">サブスクリプション配信</div>
          <div class="distribution-date__block-list-wrap">
            <div class="distribution-date__block-list">
              <div
                v-for="provider in subscriptionProviders"
                :key="provider.key"
                class="distribution-date__block-list-item">
                <div class="distribution-date__block-cell distribution-date__block-cell--th">
                  {{ provider.display_name }}
                </div>
                <div class="distribution-date__block-cell distribution-date__block-cell--td">
                  {{ provider.min_release_date | formatDate('YYYY年MM月DD日') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="distribution-date__block distribution-date__block--download">
          <div class="distribution-date__block-title">
            ダウンロード配信
          </div>
          <div class="distribution-date__block-list-wrap">
            <div class="distribution-date__block-list">
              <div
                v-for="provider in downloadProviders"
                :key="provider.key"
                class="distribution-date__block-list-item">
                <div
                  class="distribution-date__block-cell distribution-date__block-cell--th">
                  {{ provider.display_name }}
                </div>
                <div
                  class="distribution-date__block-cell distribution-date__block-cell--td">
                  {{ provider.min_release_date | formatDate('YYYY年MM月DD日') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="databaseProviders.length > 0"
          class="distribution-date__block distribution-date__block--data-base">
          <div class="distribution-date__block-title">その他</div>
          <div class="distribution-date__block-list-wrap">
            <div class="distribution-date__block-list">
              <div
                v-for="provider in databaseProviders"
                :key="provider.key"
                class="distribution-date__block-list-item">
                <div class="distribution-date__block-cell distribution-date__block-cell--th">
                  {{ provider.display_name }}
                </div>
                <div class="distribution-date__block-cell distribution-date__block-cell--td">
                  {{ provider.min_release_date | formatDate('YYYY年MM月DD日') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="distribution-date__btn--bottom">
          <div
            class="c-btn c-btn--accordion open"
            @click.prevent="onCloseClicked">
            閉じる
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MinRealeseSchedules',
  data() {
    return {
      date: '',
      minRealeaaseDetailShow: false,
      minDate: null,
      earliestReleaseDate: null,
      providers: [], // 配信先情報マスタ
    }
  },
  computed: {
    changeBtnText() {
      return this.minRealeaaseDetailShow ? '閉じる' : '詳細を見る'
    },
    downloadProviders() {
      const site = this.isBtoC ? 'b2c' : 'b2b'
      return this.providers
        .filter(provider => !provider.is_subscription && !provider.is_database_service
                       && (provider.business_direction === site || provider.business_direction === 'all'))
        .sort((provider1, provider2) => (provider1.sort_index < provider2.sort_index ? -1 : 1))
    },
    subscriptionProviders() {
      const site = this.isBtoC ? 'b2c' : 'b2b'
      return this.providers
        .filter(provider => provider.is_subscription && !provider.is_database_service
                       && (provider.business_direction === site || provider.business_direction === 'all'))
        .sort((provider1, provider2) => (provider1.sort_index < provider2.sort_index ? -1 : 1))
    },
    databaseProviders() {
      const site = this.isBtoC ? 'b2c' : 'b2b'
      return this.providers
        .filter(provider => provider.is_database_service
                       && (provider.business_direction === site || provider.business_direction === 'all'))
        .sort((provider1, provider2) => (provider1.sort_index < provider2.sort_index ? -1 : 1))
    },
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      const { data } = await window.axios.get('/api/client/providers')
      this.providers = data
      const providers = window._.orderBy(
        this.providers,
        'min_release_date',
        'desc',
      )
      const minDate = moment(new Date(window._.first(providers).min_release_date))
      this.minDate = minDate.format('YYYY年MM月DD日')
      this.date = moment(data.date).format('M月D日')
      const earliestReleaseDate = moment(new Date(window._.last(providers).min_release_date))
      this.earliestReleaseDate = earliestReleaseDate.format('YYYY年MM月DD日')
    },
    onCloseClicked() {
      this.minRealeaaseDetailShow = !this.minRealeaaseDetailShow
    },
  },
}
</script>
